import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    imports: [
        RouterModule,
        CommonModule,
        TranslateModule
    ],
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  dateYear = new Date();
  crezcoYear = this.dateYear.getFullYear();

}
